export default "__VITE_ASSET__70c7c9c8__"